import axios from 'axios';
import axiosRetry from 'axios-retry';
import { z } from 'zod';

import { refreshToken, signOut } from '@/apis/user.api.ts';
// import { NotNetworkError } from '@/errors/errors.ts';
import type { User } from '@/models';

// import { useHostStore } from '@/stores/host.store.tsx';

import { useConfig } from '../stores/config.store.ts';
import { setUser, useUserStore } from '../stores/user.store.ts';

declare module 'axios' {
  // augment AxiosRequestConfig to allow passing a zod schema per request
  export interface AxiosRequestConfig<D = any> {
    zodSchema?: z.ZodSchema<any>;
  }
}

export const req = axios.create({
  baseURL: useConfig.getState().apiBaseUrl,
  timeout: useConfig.getState().apiTimeout,
});

let countOfNoResponse = 0;

axiosRetry(req, { retries: 3, retryCondition: axiosRetry.isRetryableError });

export default req;

// export const cacheReq = setupCache(req);

const refreshRequest = {
  value: null as Promise<User> | null,
};

async function getRefreshRequest(): Promise<User> {
  if (!refreshRequest.value) {
    refreshRequest.value = refreshToken().then((user) => {
      refreshRequest.value = null;
      const newUser = {
        ...(useUserStore.getState().user as User),
        accessToken: user!.accessToken,
        refreshToken: user!.refreshToken,
      };
      setUser(newUser);
      return newUser;
    });
  }
  return refreshRequest.value;
}

export const withSchema = <T extends z.ZodTypeAny>(schema: T) => ({
  zodSchema: schema,
});

req.interceptors.request.use(
  (config) => {
    // if (useHostStore.getState().network.onlineStatus !== 'connected') {
    // return Promise.reject(new NotNetworkError());
    // }

    const token = useUserStore.getState().user?.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

req.interceptors.response.use(
  (response) => {
    const schema = response.config?.zodSchema;
    if (schema) {
      try {
        response.data = schema.parse(response.data);
      } catch (err) {
        logger.error(
          { err, url: response.config?.url, method: response.config?.method },
          'Response schema validation failed',
        );
        return Promise.reject(err);
      }
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      countOfNoResponse++;
      if (countOfNoResponse > 10) {
        // signOut();
      }
    }
    if (error.response?.status === 401) {
      const refreshToken = useUserStore.getState().user?.refreshToken;
      if (refreshToken) {
        return getRefreshRequest().then(
          () => {
            return req(error!.response!.config);
          },
          (_error) => {
            signOut();
          },
        );
      }
    }
    return Promise.reject(error);
  },
);
